import { Button } from '../../PSY/Button'
import { useLiquity } from "../../../hooks/LiquityContext";
import { useTransactionFunction } from "../../Transaction";
import { Decimal } from '@liquity/lib-base'
import { CollateralLexicon } from "src/lexicon";
import { twMerge } from 'tailwind-merge'

type Props = {
  spAddress: string
  collateralGain: Decimal
  collateralGainUSDValue: Decimal
  psyReward: Decimal
  lexicon: CollateralLexicon
  className?: string
}

export const TotalRewards: React.FC<Props> = ({ spAddress, collateralGain, collateralGainUSDValue, psyReward, lexicon, className }) => {
  const { liquity } = useLiquity();

  const [sendTransaction] = useTransactionFunction(
    "stability-deposit",
    liquity.send.withdrawGainsFromStabilityPool.bind(liquity.send, spAddress)
  );

  const disabled = collateralGain.isZero && psyReward.isZero;

  return (
    <div className={twMerge(`bg-component border-component flex flex-col md:flex-row p-5 justify-between ${className}`)}>
      <div className="flex flex-col items-start">
        <div className="text-style-sub">Total Rewards Generated</div>
        <div className='flex flex-row md:flex-col items-center md:items-start justify-between w-full'>
          <div className="flex flex-row flex-wrap mt-4">
            <div className='flex flex-row items-center'>
              <img src={lexicon.iconUrl} alt={lexicon.term} className="w-6 h-6"/>
              <div className="text-style-value ml-2">
                {collateralGain.prettify()}
                <span className='ml-0.5'>{lexicon.term}</span>
                <span className="text-style-sub ml-2">(${collateralGainUSDValue.prettify()})</span>
              </div>
            </div>
            {psyReward && psyReward.gt(0) && (
              <div className="text-style-value ml-2">+ {psyReward.prettify(3)} PSY</div>
            )}
          </div>
        </div>
      </div>
      <Button onSubmit={sendTransaction} disabled={disabled} className='flex flex-1 md:flex-none h-12 mt-3 md:mt-0 ml-3'>Claim all</Button>
    </div>
  )
}